<div (click)="goToBlueprint()" [ngClass]="{'accent-5-bg warn-solid-fg': ServiceStatus.DOWN === serviceCardInfo.status}"
     class="flex flex-col service-card cursor-pointer">
  <div class="flex flex-row justify-between mb-8">
    <div *ngIf="serviceCardInfo.status" [ngClass]="statusInfo[serviceCardInfo.status].colorClass" class="traffic-light icon-container mr-16">
      <mat-icon svgIcon="{{statusInfo[serviceCardInfo.status]?.icon}}" class="justify-center items-center white-fg icon icon-sm"></mat-icon>
    </div>
    <div class="mat-h3 mb-0 word-break-word">{{'SERVICE_STATUS.' + serviceCardInfo.status | transloco}}</div>
    <span class="flex-auto"></span>
    <button class="btn-link">
      <mat-icon svgIcon="more_vert"></mat-icon>
    </button>
    <!--  TODO : Add submenu content-->
  </div>
  <div class="mat-h1 word-break-word">{{serviceCardInfo.blueprint.name}}</div>
  <div class="mat-body word-break-word">{{serviceCardInfo.service.name}}</div>
  <mat-divider class="mt-8 mb-32"></mat-divider>

  <div *ngIf="ServiceStatus.LIVE === serviceCardInfo.status" class="flex flex-col flex-auto justify-between">
    <ng-container *ngIf="serviceCardInfo.serviceVersionsInfo.updateVersion && isUpdateAvailable; else comingSoon">
      <div class="flex flex-row justify-between light-accent-bg mb-8">
        <span class="mat-body-2">{{'SERVICE_CARD.UPDATE_AVAILABLE' | transloco}}</span>
        <mat-icon svgIcon="error_outline" class="icon-sm as-center"></mat-icon>
      </div>
    </ng-container>
    <ng-template #comingSoon>
      <ng-container *ngIf="serviceCardInfo.serviceVersionsInfo.comingSoonVersion || isComingSoon; else upToDate">
        <div class="flex flex-row justify-between light-accent-bg mb-8">
          <span class="mat-body-2">{{'SERVICE_CARD.UPDATE_COMING_SOON' | transloco}}</span>
          <mat-icon svgIcon="notifications" class="icon-sm as-center"></mat-icon>
        </div>
      </ng-container>
    </ng-template>
    <ng-template #upToDate>
      <ng-container *ngIf="changeTask?.changeState !== ChangeState.REJECTED; else rejected">
        <div class="flex flex-row justify-between w-100-percent mb-8">
          <span class="mat-body-2">{{'SERVICE_CARD.UP_TO_DATE' | transloco}}</span>
          <mat-icon svgIcon="done" class="icon-sm as-center"></mat-icon>
        </div>
      </ng-container>
    </ng-template>
    <ng-template #rejected>
      <div class="flex flex-row justify-between yellow-accent-bg mb-8">
        <span class="mat-body-2">{{'SERVICE_CARD.LATEST_UPDATE_NOT_IN_USE' | transloco}}</span>
        <mat-icon svgIcon="error_outline" class="icon-sm as-center"></mat-icon>
      </div>
    </ng-template>
    <div class="flex flex-row justify-between w-100-percent mb-8">
      <span class="mat-body-2">{{'SERVICE_CARD.SERVICE_HEALTH' | transloco}}</span>
      <mat-icon svgIcon="done" class="icon-sm as-center"></mat-icon>
    </div>
    <div class="flex flex-row justify-between w-100-percent mb-8">
      <span class="mat-body-2">{{'SERVICE_CARD.INSTANCES_DEPLOYED' | transloco}}</span>
      <span class="mat-h3 mb-0 mr-4">{{serviceCardInfo.instances?.length}}</span>
    </div>
    <div class="flex flex-row justify-between w-100-percent mb-8">
      <span class="mat-body-2">{{'SERVICE_CARD.ACTIVE_TICKETS_RELATED' | transloco}}</span>
      <span class="mat-h3 mb-0 mr-4">0</span>
    </div>
  </div>

  <div *ngIf="ServiceStatus.IN_PROGRESS === serviceCardInfo.status" class="flex flex-col flex-auto">
    <div class="flex flex-row justify-between mb-50">
      <span
        class="mat-body-2 word-break-word">{{'SERVICE_CARD.SETUP_PROGRESS.' + serviceCardInfo.currentStep | transloco}}</span>
    </div>
  </div>

  <div *ngIf="ServiceStatus.DOWN === serviceCardInfo.status" class="flex flex-col flex-auto justify-between">
    <div>Short description of a problem.</div>
    <button class="flex justify-center items-center btn-link view-ticket-button">
      <mat-icon svgIcon="open_in_new" class="flex justify-center items-center icon-sm mr-6"></mat-icon>
      <span>{{'SERVICE_CARD.VIEW_TICKET' | transloco}}</span>
    </button>
  </div>
</div>
